// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"reportsTable_mulitpleDropdown__3FJ7J","tableWrapper":"reportsTable_tableWrapper__cI9oV"};